import {createReducer} from "./index";
import {convertToDate} from "../projections";
import * as R from 'ramda';
import {ADD_DAILY_LOGS} from "../actions/dailyLog";

/*
Structure of dailylog model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        projectid: string // uuid
        owneruserid: string // uuid
        ownercompanyid: string // uuid
        createdbycompanyid: string // uuid
        createdbyuserid: string // uuid
        datecreated: datetime
        number: string
        summary: string
        logdate: date
        csicodes: array of string // code-driven code_csi
        safetyissues: string
        weatherdelays: string
        tradedelays: string
        safetydelays: string
        otherdelays: string
        active: bool
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
    projectid: {
      [projectid]:
        [logid]: dontcare
    }
  }

}
 */

const dailyLogInitial = {
  data: {},
  indexes: {
    projectid: {}
  },
};

const dailyLogReducer = createReducer(dailyLogInitial,
  {
    [ADD_DAILY_LOGS]: (state, action) => {
      let newState = state;
      action.payload.forEach(item => {
        item.resource.logdate = convertToDate(item.resource.logdate);
        item.resource.datecreated = convertToDate(item.resource.datecreated);
        newState = R.over(R.lensPath(['data', item.resource.id]), () => item)(newState);
        newState = R.over(R.lensPath(['indexes', 'projectid', item.resource.projectid]), value => {
          if (!value) {
            return {[item.resource.id]: 1};
          } else {
            return {...value, [item.resource.id]: 1};
          }
        })(newState);
      });
      return newState;
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default dailyLogReducer;



// WEBPACK FOOTER //
// ./src/reducers/dailyLog.js